import Vue from 'vue'

export default Vue.extend({
  template: `
    <div class="custom-title">
        <span class="custome-method-title">{{ value }}</span>
        <span class="custome-method-title" v-if="params.data.estimateMethod === 2 && (percentage || percentage === 0)">
          ({{ percentage }}%)
        </span>
        <span class="custome-method-title" v-if="params.data.estimateMethod === 1 && (variance || variance === 0)">
          ({{ variance }})
        </span>
    </div>
`,

  data() {
    return {
      value: undefined,
      percentage: undefined,
      variance: undefined,
    }
  },

  created() {
    this.value =
      this.params.data.estimateMethod === 1
        ? 'Variance'
        : this.params.data.estimateMethod === 2
          ? 'Residual'
          : undefined
    this.percentage =
      this.params.data.estimateMethod === 2
        ? parseFloat(this.params.data.residualPercentage).toFixed(2)
        : this.params.data.estimateMethod === 2 &&
          isNaN(this.params.data.residualPercentage)
          ? 0.0
          : this.params.data.estimateMethod === 2 &&
          this.params.data.residualPercentage === 'Infinity'
            ? 0.0
            : undefined
    this.variance =
      this.params.data.estimateMethod === 1 && this.params.data.variance
        ? parseFloat(this.params.data.variance).toFixed(2)
        : this.params.data.estimateMethod === 1 &&
          isNaN(this.params.data.variance)
          ? undefined
          : this.params.data.estimateMethod === 1 &&
          this.params.data.variance === 'Infinity'
            ? undefined
            : undefined
  },
})
